import { API } from "api";

export const getFunctionalLoacatioIdnAPI = (id) => {
    return API.get(`/api/functionallocation/${id}`)
                .then((res) => res);
};
